import { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'

import { createUser } from '../../../../main/usecases'

import { useForm } from '../../../hooks'
import { goToUrl } from '../../../utils'
import { Button, Input } from '../../../components'
import { CardContainer } from '../../../components/ui/components'

import { ArrowRightSvg, FullLogoSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'

const Signup = () => {
  const username = useForm()
  const email = useForm('email')
  const history = useHistory()
  const [checkBoxState, setCheckBoxState] = useState(false)

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      email: email.value,
      nome: username.value
    }

    try {
      await createUser().post(body)
    } catch (error) {
      console.error(error)
    }
  }

  const redirectToSignUpPassword = () => {
    goToUrl(history, '/cadastro-senha', {
      username: username.value,
      email: email.value
    })
  }

  return (
    <S.Wrapper>
      <CardContainer style="container">
        <S.Content>
          <FullLogoSvg
            colorX="#00995D"
            colorLetters="#6F6F6E"
            width="182"
            height="42"
          />
          <S.Subtitle>Seja bem-vindo(a)!</S.Subtitle>
          <S.Description>Preencha os campos para se cadastrar</S.Description>
          <Input
            labelColor="#4F4F4F"
            label="Nome"
            type="text"
            name="username"
            {...username}
          />
          <Input
            onKeyUp={() => email.validate()}
            labelColor="#4F4F4F"
            label="E-mail"
            type="email"
            name="email"
            {...email}
          />
          <Input
            name="signUpTerms"
            wrapperClassName="signUpTerms"
            labelColor="#4F4F4F"
            type="checkbox"
            onChange={() => setCheckBoxState(!checkBoxState)}
            label={[
              'Estou de acordo com os ',
              <a
                href="https://wexer.com.br/contents/termos-de-servicos-e-condicoes-gerais-de-uso-wexer-psi"
                target="_blank"
                rel="noreferrer"
              >
                Termos de uso
              </a>
            ]}
          ></Input>
          <S.ButtonContainer>
            {username.value && email.value && !email.error && checkBoxState ? (
              <Button
                onClick={(e: any) => {
                  onSubmit(e)
                  redirectToSignUpPassword()
                }}
                endIcon={<ArrowRightSvg className="icon-arrow-right" />}
              >
                {/* <Link
                  to={`cadastro-senha?username=${username.value}&email=${email.value}`}
                > */}
                Prosseguir
                {/* </Link> */}
              </Button>
            ) : (
              <Button
                disabled
                onClick={onSubmit}
                endIcon={<ArrowRightSvg className="icon-arrow-right" />}
              >
                <Link to="#">Prosseguir</Link>
              </Button>
            )}
          </S.ButtonContainer>
        </S.Content>
      </CardContainer>
    </S.Wrapper>
  )
}
export default Signup
